import { ProductOrBrand } from "./alternativeTypes";

export const carsProducts: ProductOrBrand[] = [
  {
    name: "Tesla",
    ownerCountry: "US",
    categories: ["cars"],
  },
  {
    name: "Ford",
    ownerCountry: "US",
    categories: ["cars"],
  },

  {
    name: "Volkswagen",
    ownerCountry: "DE",
    categories: ["cars"],
  },
  {
    name: "Peugeot",
    ownerCountry: "NL", // Stellantis
    headquarterIn: "FR",
    comments: "Peugeot is a French automobile manufacturer founded in 1810, initially producing coffee mills and bicycles before transitioning to automobiles in 1889. Known for its innovative designs and engineering, Peugeot has a significant presence in the European automotive market and is part of the Stellantis group.", 
    categories: ["cars"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Peugeot", "https://www.stellantis.com/en/brands/peugeot"] 
  },
  {
    name: "Fiat",
    ownerCountry: "NL", // Stellantis
    headquarterIn: "IT",
    comments: "Fiat is an Italian automobile manufacturer established in Turin in 1899. Known for designing small and medium-sized city and family cars, Fiat became part of Fiat Chrysler Automobiles in 2014, which later merged with PSA Group in 2021 to form Stellantis. Fiat remains a global brand, committed to making mobility accessible to everyone.", 
    categories: ["cars"], 
    sourceLinks: ["https://en.wikipedia.org/wiki/Fiat", "https://www.stellantis.com/en/brands/fiat"] 
    },
  {
    name: "Renault",
    ownerCountry: "FR",
    comments: "Renault is a French multinational automobile manufacturer established in 1899. The company produces a range of cars and vans and has previously manufactured trucks, tractors, tanks, buses/coaches, aircraft, and aircraft engines. Renault is part of the Renault-Nissan-Mitsubishi Alliance, a strategic partnership among the three automakers. The company's brands include Renault, Dacia, Alpine, and Mobilize.", 
    categories: ["cars"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Renault", "https://www.renaultgroup.com/en/our-brands"] 
  },
  { 
    name: "Alfa Romeo", 
    ownerCountry: "NL", // Stellantis 
    headquarterIn: "IT", 
    availableIn: ["AL", "AM", "AT", "BE", "BA", "BG", "HR", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "IS", "IE", "IT", "LV", "LT", "LU", "MT", "MD", "ME", "NL", "MK", "NO", "PL", "PT", "RO", "SI", "ES", "SE", "CH", "TR", "UA", "UK"], 
    comments: "Alfa Romeo is an Italian automobile manufacturer founded in 1910 in Milan. Known for its sporty vehicles and rich automotive history, it became a subsidiary of Stellantis in 2021. The brand has a strong presence in Europe, offering models like the Giulia sedan, Stelvio SUV, and the recently introduced Tonale compact SUV.", 
    categories: ["cars"], 
    sourceLinks: ["https://en.wikipedia.org/wiki/Alfa_Romeo", "https://www.stellantis.com/en/brands/alfa-romeo"] 
  },
  { 
    name: "SEAT", 
    ownerCountry: "DE", 
    headquarterIn: "ES", 
    availableIn: ["AL", "AM", "AT", "BE", "BA", "BG", "HR", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "IS", "IE", "IT", "LV", "LT", "LU", "MT", "MD", "ME", "NL", "MK", "NO", "PL", "PT", "RO", "SI", "ES", "SE", "CH", "TR", "UA", "UK"], 
    comments: "SEAT is a Spanish automobile manufacturer founded in 1950. Initially a state-owned company, it became a subsidiary of the Volkswagen Group in 1986. SEAT produces a range of vehicles under the SEAT and CUPRA brands, with a focus on design and performance. The company is headquartered in Martorell, Spain, and exports to over 75 countries worldwide.", 
    categories: ["cars"], 
    sourceLinks: ["https://www.seat.com/company/history", "https://en.wikipedia.org/wiki/SEAT"] 
  },
  {
    name: "Dacia",
    ownerCountry: "FR",
    headquarterIn: "RO",
    notAvailableIn: ["AM", "UA", "AU", "CA", "MX"],
    categories: ["cars"],
    sourceLinks: [
      "https://www.goodcarbadcar.net/dacia-europe-sales-figures/",
      "https://www.goodcarbadcar.net/data-center/europe-car-sales-data-reports/"
    ]
  },
  {
    name: "Audi",
    ownerCountry: "DE",
    categories: ["cars"],
  },
  {
    name: "BMW",
    ownerCountry: "DE",
    categories: ["cars"],
  },
  {
    name: "Skoda",
    ownerCountry: "DE",
    headquarterIn: "CZ",
    categories: ["cars"],
  },
  {
    name: "Vauxhall",
    ownerCountry: "NL",
    headquarterIn: "UK",
    availableIn: ["UK"],
    categories: ["cars"],
  },
];